import React from 'react';
import UIStrings from '@/Utils/UIStrings';

function CTMonitoringTooltipBody(): React.JSX.Element {
    const listItems = [
        UIStrings.ApplicantTestMonitoringExplanations1,
        UIStrings.ApplicantTestMonitoringExplanations2,
        UIStrings.ApplicantTestMonitoringExplanations3,
    ];

    return (
        <div className="flex min-w-84 flex-col gap-4 text-left">
            <p className="text-foreground text-sm font-semibold">{UIStrings.ApplicantTestMonitoring}</p>
            {listItems.map((listItem) => (
                <p key={listItem} className="text-foreground text-xs leading-relaxed">
                    {listItem}
                </p>
            ))}
        </div>
    );
}

export default CTMonitoringTooltipBody;
